<script>
  import { categoryOpenStates } from '../../../../../js/stores';

  function shouldDisplayScrim(openStates) {
    if (!(openStates instanceof Map)) {
      return false;
    }

    return Array.from(openStates.values()).includes(true);
  }
</script>

<div
  class="Scrim"
  class:isVisible={shouldDisplayScrim($categoryOpenStates)}
  style="visibility: var(--scrim-visibility, hidden)"
  aria-hidden="true"
></div>

<style>.Scrim {
  box-sizing: border-box;
  z-index: 2;
  display: block;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  --scrim-visibility: hidden;
  pointer-events: none;
  transition: pointer-events 0ms, visibility 0ms 200ms, opacity 200ms cubic-bezier(0.4, 0, 1, 1);
}

.isVisible {
  opacity: 1;
  --scrim-visibility: visible;
  pointer-events: auto;
  transition: visibility 0ms, pointer-events 0ms 250ms, opacity 250ms cubic-bezier(0, 0, 0.2, 1);
}</style>
